import DOMPurify, { sanitize } from 'isomorphic-dompurify'
import { forbidenTagsForEditors } from 'Constants/sanitize'

const regExp =
	/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|xxx|blob):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i

export const sanitizeHtml = (
	html: string,
	options?: DOMPurify.Config & { RETURN_DOM_FRAGMENT?: false; RETURN_DOM?: false }
) => {
	return sanitize(html, {
		ALLOWED_URI_REGEXP: regExp,
		...options,
	})
}

const keysBodySanitize = ['time', 'id', 'type', 'withHeadings', 'divider', 'style', 'version']

export const reckSanitize = (body) => {
	const ans = body
	Object.keys(body).forEach((key) => {
		if (!keysBodySanitize.includes(key)) {
			if (typeof body[key] === 'string') {
				ans[key] = sanitizeHtml(ans[key], forbidenTagsForEditors)
			} else {
				ans[key] = reckSanitize(ans[key])
			}
		}
	})
	return ans
}
